module.exports = __webpack_public_path__ + "static/img/product.b7a796ea.png";